import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";

const SubscriberRemarksPopup = ({ subscriberData }) => {
  const { register, handleSubmit, reset } = useForm();
  const [remarks, setRemarks] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (subscriberData) {
      fetchRemarks();
    }
  }, [subscriberData]);

  const fetchRemarks = async () => {
    try {
      const response = await axios.get(`${apiUrl}/campaign/contacts/${subscriberData.id}/remarks`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setRemarks(response.data.remarks || []);
    } catch (error) {
      console.error("Error fetching remarks:", error);
      toast.error("Failed to fetch remarks. Please try again later.");
   }
  };

  const onSubmit = async (data) => {
    if (!data.note) {
      toast.error("Remark note is required");
      return;
    }
    const remark = {
      note: data.note,
      date: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    try {
      await axios.post(`${apiUrl}/campaign/contacts/remark/${subscriberData.id}`, { remark }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Remark added successfully");
      reset();
      fetchRemarks();
    } catch (error) {
      toast.error("Failed to add remark. Please try again later.");
    }
  };

  return (
    <div id="manage_remarks" className="modal custom-modal fade" role="dialog">
      <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "100vh", width: "40%" }}>
        <div className="modal-content h-100 d-flex flex-column">
          <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column h-100">
            <div className="modal-header">
              <h5 className="modal-title">Manage Remarks for {subscriberData?.name}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body flex-grow-1 overflow-auto" style={{ maxHeight: "calc(100vh - 120px)" }}>
              <div className="scrollable-container">
                <div className="remarks-list mb-3">
                  {remarks.length > 0 ? (
                    remarks.map((remark, index) => (
                      <div key={index} className="remark-item border-bottom py-2">
                        <p><strong>{remark.date}:</strong> {remark.note}</p>
                      </div>
                    ))
                  ) : (
                    <p>No remarks available.</p>
                  )}
                </div>

                <div className="form-group row mb-3">
                  <label className="col-md-4 col-form-label">
                    Add New Remark <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-8">
                    <textarea
                      className="form-control"
                      rows="3"
                      {...register("note")}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button className="btn btn-primary submit-btn" type="submit">
                Add Remark
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SubscriberRemarksPopup;